export default __webpack_public_path__ + "static/media/Peace Sans.f59a8de8.otf";